module.exports = __webpack_public_path__ + "static/media/04_touch-sensing-module.acbe0995.mp4";